import React from 'react';
import axios from 'axios';
import ReactSummernote from 'react-summernote';
import 'react-summernote/dist/react-summernote.css';
import sanitizeHtml from 'sanitize-html';

import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/tooltip';

import './summernote/audio';
import './summernote/audio.css';

const uploadFile = (file, api) => {
  const fd = new FormData();

  fd.append('file', file);

  return axios({
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: fd,
    ...api,
  });
};

class Note extends ReactSummernote {
  get callbacks() {
    return {
      ...super.callbacks,
      onAudioUpload: this.props.onAudioUpload,
    };
  }

  componentDidMount() {
    super.componentDidMount();

    // disable file drop to contenteditables
    this.noteEditable.bind('dragover drop', (e) => {
      e.preventDefault();

      return false;
    });
  }
}

const Summernote = ({
  value,
  injectValue,
  onChange,
  onBlur,
  fileUploadUrl,
  options = {},
  disabled,
}) => (
    <Note
      {...injectValue ? { value } : {} }
      onInit={function init(note) {
        note.replace(value);
      }}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      options={{
        height: 350,
        disableDragAndDrop: true,
        dialogsInBody: true,
        styleTags: ['p', 'blockquote', 'h2', 'h3', 'h4', 'h5', 'h6'],
        toolbar: [
          ['style', ['style']],
          ['font', [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'color',
            'clear',
          ]],
          ['para', ['ul', 'ol', 'paragraph']],
          ['table', ['table']],
          ['insert', ['hr', 'link', 'picture', 'video', 'audio']],
          ['view', ['codeview', 'undo', 'redo']],
        ],
        ...options,
      }}
      onPaste={(e) => {
        const clipboard = (
          (e.originalEvent || e).clipboardData || window.clipboardData
        );
        const html = clipboard.getData('text/html');
        const text = clipboard.getData('text');

        e.preventDefault();

        if (html) {
          const toPaste = sanitizeHtml(html, {
            allowedAttributes: {
              '*': ['style'],
              a: ['href', 'name', 'target'],
              img: ['src'],
            },
            allowedStyles: {
              '*': {
                color: [
                  /^#(0x)?[0-9a-f]+$/i,
                  /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
                ],
                'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/],
              },
            },
          });

          document.execCommand(
            'insertHTML',
            false,
            toPaste,
          );
        } else {
          document.execCommand('insertText', false, text);
        }
      }}
      onImageUpload={async (files, insertImage) => {
        const res = await uploadFile(files[0], { url: fileUploadUrl });
        const { url } = res.data;

        insertImage(url);
      }}
      onAudioUpload={async (files, insertAudio) => {
        const res = await uploadFile(files[0], { url: fileUploadUrl });
        const { url } = res.data;

        insertAudio(url);
      }}
    />
);

export default Summernote;
